import React, { useState, useEffect } from "react";

import { useSearchParams } from "react-router-dom";

import axiosInstance from "../helpers/axios";

import { EnvironmentOutlined } from "@ant-design/icons";
import { Typography, Button } from "antd";

const { Title, Text } = Typography;

const LocationPlaceOrder = () => {
  const [searchParams] = useSearchParams();
  const psid = searchParams.get("psid");
  const pageId = searchParams.get("pageId");

  const token = searchParams.get("token");
  const order = searchParams.get("order");
  const name = searchParams.get("name");
  const contact = searchParams.get("contact");
  const merchantId = searchParams.get("merchantId");
  const branchId = searchParams.get("branchId");
  const note = searchParams.get("note");

  const [loading, setLoading] = useState(false);
  const [greeting, setGreeting] = useState("");

  useEffect(() => {
    const hour = new Date().getHours();
    setGreeting(
      hour < 12
        ? "Good Morning!"
        : hour < 18
        ? "Good Afternoon!"
        : "Good Evening!"
    );
  }, []);

  const getLocation = () => {
    setLoading(true);

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;

          try {
            const finalData = {
              psid,
              order,
              fullName: name,
              contactNumber: contact,
              merchantId,
              branchId,
              token,
              latitude,
              longitude,
              note,
            };

            const response = await axiosInstance().post(
              "https://api.dorydelivery.com/api/orders/place-order-v4",
              finalData
            );

            if (response.status === 201) {
              const userAgent = navigator.userAgent.toLowerCase();
              const isAndroid = /android/i.test(userAgent);
              const isIOS = /iphone|ipad|ipod/i.test(userAgent);
              if (isAndroid) {
                const messengerUrl = `intent://m.me/${pageId}#Intent;package=com.facebook.orca;scheme=https;end;`;
                window.location.href = messengerUrl;
                setTimeout(() => {
                  window.close();
                }, 500);
              } else if (isIOS) {
                const messengerUrl = `fb-messenger://user-thread/${pageId}`;
                window.location.href = messengerUrl;
                setTimeout(() => {
                  if (window.opener) {
                    window.close();
                  }
                }, 500);
              } else {
                window.location.href = `https://m.me/${pageId}`;
              }
            } else {
              console.error("Failed to save location data");
            }
          } catch (error) {
            console.error("Error during location data submission:", error);
          } finally {
            setLoading(false);
          }
        },
        (error) => {
          setLoading(false);
          if (error.code === error.PERMISSION_DENIED) {
            alert(
              "Location permission is required for this feature. Please allow location access."
            );
          } else {
            alert("An error occurred while accessing your location.");
          }
        }
      );
    } else {
      setLoading(false);
      alert("Geolocation is not supported by this browser.");
    }
  };

  return (
    <>
      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "20px",
        }}
      >
        <Title
          level={2}
          style={{
            position: "relative",
            zIndex: 1,
            marginBottom: 0,
          }}
        >
          {greeting}
        </Title>
        <Text
          style={{
            fontWeight: "bold",
            color: "#00f57f",
            fontSize: 24,
            marginLeft: 16,
            marginBottom: 16,
          }}
        >
          Please share your location.
        </Text>
        <div style={{ marginTop: "30px" }}>
          <Button
            onClick={getLocation}
            type="primary"
            loading={loading}
            icon={<EnvironmentOutlined />}
            size="large"
            style={{
              height: 80,
              padding: "20px 30px",
              fontSize: "20px",
              backgroundColor: "black",
              color: "white",
              borderColor: "black",
              width: "250px",
            }}
          >
            {loading ? "Locating..." : "Share Location"}
          </Button>
        </div>
      </div>
    </>
  );
};

export default LocationPlaceOrder;
